import { defineComponent, ref } from "vue";
import { api } from "~/api/index";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { commonStore } from "~/store/CommonStore";
import { useRouter } from "vue-router";
import Loading from 'quasar/src/plugins/loading/Loading.js';
import { auth } from "~/core/Auth";
const log = Log.create("TermsOfUseComfirmPage");
export default defineComponent({
    name: "TermsOfUseConfirm",
    async setup() {
        let html = ref("");
        let agree = ref(false);
        let presenceMessage = commonStore.messages.PV0002;
        const router = useRouter();
        const onClick = async () => {
            try {
                await api.termsOfUse.agree();
                await auth.init();
                router.push({ name: "top" });
            }
            catch (ex) {
                log.error("onClick", ex);
                MsgBox.error(ex.data.errorMessage);
            }
            finally {
                Loading.hide();
            }
        };
        try {
            let result = await api.termsOfUse.loadTermOfUseText();
            html.value = result;
        }
        catch (ex) {
            log.error("setup", ex);
            MsgBox.error(ex.message);
        }
        return {
            html,
            agree,
            presenceMessage,
            onClick
        };
    }
});
